<template>
  <div>



      <vs-divider class="mt-10 mb-10"> Company Information </vs-divider>
      <add-company-component :company-data-prop="null" />
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import AddCompanyComponent from "../../components/AddCompanyComponent";

  export default {
    name: "Add",
    components: {AddCompanyComponent},
    data() {
      return {
        hostawayID: null,
        hoteltaskRoomTypeShortCode : null,
        propertyComponentKey: 0
      }
    },
    computed: {
      ...mapGetters({
        isLoading: 'companies/isLoading',
        error: 'companies/error',
      })
    },
    methods: {
      ...mapActions({
        loadListingApiData: 'get',
      }),
      errorNotify(msg){
        this.$vs.notify({color:'danger',title:'Error',text:msg})
      },
    },
    watch: {
      isLoading(newValue) {
        if (newValue) {
          this.$vs.loading()
        }else {
          this.$vs.loading.close()
        }
      },
    },
  }
</script>

<style scoped>

</style>
